<agpr-dialog-container
    class="agpr-chartAnnotationDialog agpr-chartAnnotationDialog--allowOverflow"
    [showHeader]="false"
    [hideFooter]="true"
    [contentPadding]="false"
>
    <div #container class="agpr-chartAnnotationDialog-container">
        <div #chartContainer class="agpr-chartAnnotationDialog-chartContainer">
            <agpr-am5-chart
                class="agpr-chartAnnotationDialog-chart"
                [chart]="chart"
                [series]="reportSeries"
            ></agpr-am5-chart>
        </div>
        <div class="agpr-chartAnnotationDialog-toolboxPlaceholder"></div>
    </div>
    <!-- todo: a11y -->
    <!-- <agpr-button
        #selectButton
        class="agpr-chartAnnotationDialog-toolbar-button"
        icon="fa-duotone fa-regular fa-arrow-pointer"
    ></agpr-button> -->
    <agpr-button
        #actionCollectionButton
        class="agpr-chartAnnotationDialog-actionCollection-button"
        [ngClass]="{'agpr-chartAnnotationDialog-actionCollection-button--hidden': !actionCollectionOverflow }"
        [icon]="actionCollectionExpanded ? 'fa-solid fa-angle-up' : 'fa-solid fa-angle-down'"
        [expanded]="actionCollectionExpanded"
        (click)="toggleActionCollection()"
    ></agpr-button>
    <div
        #actionCollectionRibbon
        class="agpr-chartAnnotationDialog-actionCollection-ribbon"
        [ngClass]="{ 'agpr-chartAnnotationDialog-actionCollection-ribbon--hidden': !actionCollectionExpanded }"
        [style.width]="width"
    ></div>
    <div
        #currentMarkerIcon
        class="agpr-chartAnnotationDialog-markerCollection-currentMarker"
        [ngClass]="{
            'agpr-chartAnnotationDialog-markerCollection-currentMarker--active': markerArea?.currentMarker,
            'agpr-chartAnnotationDialog-markerCollection-currentMarker--hidden': !markerCollectionOverflow
        }"
    >
        <span
            [ngClass]="currentMarkerIconClass"
        ></span>
    </div>
    <agpr-button
        #markerCollectionButton
        class="agpr-chartAnnotationDialog-markerCollection-button"
        [ngClass]="{'agpr-chartAnnotationDialog-markerCollection-button--hidden': !markerCollectionOverflow }"
        [icon]="markerCollectionExpanded ? 'fa-solid fa-angle-up' : 'fa-solid fa-angle-down'"
        [expanded]="markerCollectionExpanded"
        (click)="toggleMarkerCollection()"
    ></agpr-button>
    <div
        #markerCollectionRibbon
        class="agpr-chartAnnotationDialog-markerCollection-ribbon"
        [ngClass]="{ 'agpr-chartAnnotationDialog-markerCollection-ribbon--hidden': !markerCollectionExpanded }"
        [style.width]="width"
    ></div>
    <agpr-button
        #lineCollectionButton
        class="agpr-chartAnnotationDialog-lineCollection-button"
        icon="fa-solid fa-dash"
        [active]="lineCollectionExpanded"
        (click)="toggleLineCollection()"
    ></agpr-button>
    <div
        #lineCollectionRibbon
        class="agpr-chartAnnotationDialog-lineCollection-ribbon"
        [ngClass]="{ 'agpr-chartAnnotationDialog-lineCollection-ribbon--hidden': !lineCollectionExpanded }"
        [style.width]="width"
    ></div>
    <agpr-button
        #shapeCollectionButton
        class="agpr-chartAnnotationDialog-shapeCollection-button"
        icon="fa-duotone fa-regular fa-shapes"
        [active]="shapeCollectionExpanded"
        (click)="toggleShapeCollection()"
    ></agpr-button>
    <div
        #shapeCollectionRibbon
        class="agpr-chartAnnotationDialog-shapeCollection-ribbon"
        [ngClass]="{ 'agpr-chartAnnotationDialog-shapeCollection-ribbon--hidden': !shapeCollectionExpanded }"
        [style.width]="width"
    ></div>
    <agpr-button
        #textCollectionButton
        class="agpr-chartAnnotationDialog-textCollection-button"
        icon="fa-solid fa-t"
        [active]="textCollectionExpanded"
        (click)="toggleTextCollection()"
    ></agpr-button>
    <div
        #textCollectionRibbon
        class="agpr-chartAnnotationDialog-textCollection-ribbon"
        [ngClass]="{ 'agpr-chartAnnotationDialog-textCollection-ribbon--hidden': !textCollectionExpanded }"
        [style.width]="width"
    ></div>
    @if (indicatorGroups.length > 0) {
        <agpr-multi-select-dropdown
            #indicatorCollectionDropdown
            class="agpr-chartAnnotationDialog-indicatorCollection-button"
            [id]="'chartAnnotationDialog_indicatorDropdownOptions'"
            panelStyleClass="agpr-chartAnnotationDialog-indicatorCollection-panel"
            [alignPanelRight]="true"
            [displayChips]="false"
            [optionsListGroups]="indicatorGroups"
            icon="fa-duotone fa-regular fa-chart-line"
            [ngModel]="selectedIndicators"
            (ngModelChange)="updateIndicators($event)"
        ></agpr-multi-select-dropdown>
    }

    <div
        #freehandLineWidthRadioGroup
        class="agpr-chartAnnotationDialog-radioContainer"
    >
        <ng-container
            *ngTemplateOutlet="radioGroup; context:
                {
                    options: lineWidthOptions,
                    model: selectedFreehandLineWidth,
                    markerType: chartAnnotationMarkerTypes.FREEHAND_MARKER,
                    styleType: chartAnnotationMarkerStyleTypes.LINE_WIDTH
                }"
        ></ng-container>
    </div>

    <div
        #lineStrokeWidthRadioGroup
        class="agpr-chartAnnotationDialog-radioContainer"
    >
        <ng-container
            *ngTemplateOutlet="radioGroup; context:
                {
                    options: lineWidthOptions,
                    model: selectedLineStrokeWidth,
                    markerType: chartAnnotationMarkerTypes.LINE_MARKER,
                    styleType: chartAnnotationMarkerStyleTypes.STROKE_WIDTH
                }"
        ></ng-container>
    </div>
    <div
        #lineLineStyleRadioGroup
        class="agpr-chartAnnotationDialog-radioContainer"
    >
        <ng-container
            *ngTemplateOutlet="radioGroup; context:
                {
                    options: lineStyleOptions,
                    model: selectedLineLineStyle,
                    markerType: chartAnnotationMarkerTypes.LINE_MARKER,
                    styleType: chartAnnotationMarkerStyleTypes.LINE_STYLE
                }"
        ></ng-container>
    </div>
    <div
        #arrowStrokeWidthRadioGroup
        class="agpr-chartAnnotationDialog-radioContainer"
    >
        <ng-container
            *ngTemplateOutlet="radioGroup; context:
                {
                    options: lineWidthOptions,
                    model: selectedArrowStrokeWidth,
                    markerType: chartAnnotationMarkerTypes.ARROW_MARKER,
                    styleType: chartAnnotationMarkerStyleTypes.STROKE_WIDTH
                }"
        ></ng-container>
    </div>
    <div
        #arrowLineStyleRadioGroup
        class="agpr-chartAnnotationDialog-radioContainer"
    >
        <ng-container
            *ngTemplateOutlet="radioGroup; context:
                {
                    options: lineStyleOptions,
                    model: selectedArrowLineStyle,
                    markerType: chartAnnotationMarkerTypes.ARROW_MARKER,
                    styleType: chartAnnotationMarkerStyleTypes.LINE_STYLE
                }"
        ></ng-container>
    </div>
    <div
        #arrowArrowTypeRadioGroup
        class="agpr-chartAnnotationDialog-radioContainer"
    >
        <ng-container
            *ngTemplateOutlet="radioGroup; context:
                {
                    options: arrowTypeOptions,
                    model: selectedArrowArrowType,
                    markerType: chartAnnotationMarkerTypes.ARROW_MARKER,
                    styleType: chartAnnotationMarkerStyleTypes.ARROW_TYPE
                }"
        ></ng-container>
    </div>
    <div
        #curveStrokeWidthRadioGroup
        class="agpr-chartAnnotationDialog-radioContainer"
    >
        <ng-container
            *ngTemplateOutlet="radioGroup; context:
                {
                    options: lineWidthOptions,
                    model: selectedCurveStrokeWidth,
                    markerType: chartAnnotationMarkerTypes.CURVE_MARKER,
                    styleType: chartAnnotationMarkerStyleTypes.STROKE_WIDTH
                }"
        ></ng-container>
    </div>
    <div
        #curveLineStyleRadioGroup
        class="agpr-chartAnnotationDialog-radioContainer"
    >
        <ng-container
            *ngTemplateOutlet="radioGroup; context:
                {
                    options: lineStyleOptions,
                    model: selectedCurveLineStyle,
                    markerType: chartAnnotationMarkerTypes.CURVE_MARKER,
                    styleType: chartAnnotationMarkerStyleTypes.LINE_STYLE
                }"
        ></ng-container>
    </div>

    <div
        #frameStrokeWidthRadioGroup
        class="agpr-chartAnnotationDialog-radioContainer"
    >
        <ng-container
            *ngTemplateOutlet="radioGroup; context:
                {
                    options: lineWidthOptions,
                    model: selectedFrameStrokeWidth,
                    markerType: chartAnnotationMarkerTypes.FRAME_MARKER,
                    styleType: chartAnnotationMarkerStyleTypes.STROKE_WIDTH
                }"
        ></ng-container>
    </div>
    <div
        #frameLineStyleRadioGroup
        class="agpr-chartAnnotationDialog-radioContainer"
    >
        <ng-container
            *ngTemplateOutlet="radioGroup; context:
                {
                    options: lineStyleOptions,
                    model: selectedFrameLineStyle,
                    markerType: chartAnnotationMarkerTypes.FRAME_MARKER,
                    styleType: chartAnnotationMarkerStyleTypes.LINE_STYLE
                }"
        ></ng-container>
    </div>
    <div
        #ellipseStrokeWidthRadioGroup
        class="agpr-chartAnnotationDialog-radioContainer"
    >
        <ng-container
            *ngTemplateOutlet="radioGroup; context:
                {
                    options: lineWidthOptions,
                    model: selectedEllipseStrokeWidth,
                    markerType: chartAnnotationMarkerTypes.ELLIPSE_MARKER,
                    styleType: chartAnnotationMarkerStyleTypes.STROKE_WIDTH
                }"
        ></ng-container>
    </div>
    <div
        #ellipseLineStyleRadioGroup
        class="agpr-chartAnnotationDialog-radioContainer"
    >
        <ng-container
            *ngTemplateOutlet="radioGroup; context:
                {
                    options: lineStyleOptions,
                    model: selectedEllipseLineStyle,
                    markerType: chartAnnotationMarkerTypes.ELLIPSE_MARKER,
                    styleType: chartAnnotationMarkerStyleTypes.LINE_STYLE
                }"
        ></ng-container>
    </div>

    <agpr-advanced-color-picker-popover
        #freehandColorPicker
        class="agpr-chartAnnotationDialog-colorPicker"
        (close)="closeColorPicker($event)"
    ></agpr-advanced-color-picker-popover>
    <agpr-advanced-color-picker-popover
        #lineStrokeColorPicker
        class="agpr-chartAnnotationDialog-colorPicker"
        (close)="closeColorPicker($event)"
    ></agpr-advanced-color-picker-popover>
    <agpr-advanced-color-picker-popover
        #arrowStrokeColorPicker
        class="agpr-chartAnnotationDialog-colorPicker"
        (close)="closeColorPicker($event)"
    ></agpr-advanced-color-picker-popover>
    <agpr-advanced-color-picker-popover
        #curveStrokeColorPicker
        class="agpr-chartAnnotationDialog-colorPicker"
        (close)="closeColorPicker($event)"
    ></agpr-advanced-color-picker-popover>
    <agpr-advanced-color-picker-popover
        #frameStrokeColorPicker
        class="agpr-chartAnnotationDialog-colorPicker"
        (close)="closeColorPicker($event)"
    ></agpr-advanced-color-picker-popover>
    <agpr-advanced-color-picker-popover
        #ellipseStrokeColorPicker
        class="agpr-chartAnnotationDialog-colorPicker"
        (close)="closeColorPicker($event)"
    ></agpr-advanced-color-picker-popover>
    <agpr-advanced-color-picker-popover
        #ellipseFillColorPicker
        class="agpr-chartAnnotationDialog-colorPicker"
        (close)="closeColorPicker($event)"
    ></agpr-advanced-color-picker-popover>
    <agpr-advanced-color-picker-popover
        #highlightFillColorPicker
        class="agpr-chartAnnotationDialog-colorPicker"
        (close)="closeColorPicker($event)"
    ></agpr-advanced-color-picker-popover>
    <agpr-advanced-color-picker-popover
        #textColorPicker
        class="agpr-chartAnnotationDialog-colorPicker"
        (close)="closeColorPicker($event)"
    ></agpr-advanced-color-picker-popover>
    <agpr-advanced-color-picker-popover
        #calloutColorPicker
        class="agpr-chartAnnotationDialog-colorPicker"
        (close)="closeColorPicker($event)"
    ></agpr-advanced-color-picker-popover>
    <agpr-advanced-color-picker-popover
        #calloutColorPicker
        class="agpr-chartAnnotationDialog-colorPicker"
        (close)="closeColorPicker($event)"
    ></agpr-advanced-color-picker-popover>
    <agpr-advanced-color-picker-popover
        #calloutBgColorPicker
        class="agpr-chartAnnotationDialog-colorPicker"
        (close)="closeColorPicker($event)"
    ></agpr-advanced-color-picker-popover>

    <agpr-slider-input
        #highlightOpacitySliderInput
        class="agpr-chartAnnotationDialog-opacitySliderInput"
        [showMinMaxLabels]="true"
        [showValue]="false"
    ></agpr-slider-input>
    <agpr-slider-input
        #ellipseOpacitySliderInput
        class="agpr-chartAnnotationDialog-opacitySliderInput"
        [showMinMaxLabels]="true"
        [showValue]="false"
    ></agpr-slider-input>

    <agpr-dropdown
        #textFontFamilyDropdown
        class="agpr-chartAnnotationDialog-fontFamilyDropdown"
        [options]="fontFamilyDropdownOptions"
        [bindToValue]="true"
        [dropdownContainerStyleClass]="'fontFamilyDropdownContainer'"
    ></agpr-dropdown>
    <agpr-dropdown
        #calloutFontFamilyDropdown
        class="agpr-chartAnnotationDialog-fontFamilyDropdown"
        [options]="fontFamilyDropdownOptions"
        [bindToValue]="true"
        [dropdownContainerStyleClass]="'fontFamilyDropdownContainer'"
    ></agpr-dropdown>
</agpr-dialog-container>

<ng-template
    #radioGroup
    let-options="options"
    let-model="model"
    let-markerType="markerType"
    let-styleType="styleType"
>
    @for (option of options; track option.value; let i = $index) {
        <agpr-radio
            class="agpr-chartAnnotationDialog-toolboxPanelRadio"
            [ngClass]="{
                'agpr-chartAnnotationDialog-toolboxPanelRadio--padded':
                    (styleType === chartAnnotationMarkerStyleTypes.STROKE_WIDTH || styleType === chartAnnotationMarkerStyleTypes.LINE_WIDTH)
                    && i % 2 === 0,
                'agpr-chartAnnotationDialog-toolboxPanelRadio--small': styleType === chartAnnotationMarkerStyleTypes.LINE_STYLE

            }"
            [id]="markerType + '_' + styleType"
            [name]="markerType + styleType"
            [value]="option.value"
            [style]="radioTypes.button"
            [icon]="option.icon"
            [defaultFAIconPrefix]="styleType === chartAnnotationMarkerStyleTypes.ARROW_TYPE"
            [ngModel]="model"
            (ngModelChange)="radioChanged(option.value, markerType, styleType)"
        ></agpr-radio>
    }
</ng-template>